import { Button, WidgetInput, Input, } from '@yellowcard/components-library-vue3';
import { computed, defineComponent, onBeforeMount, ref, watch } from 'vue';
import { useKycStore } from '@/store/modules/kyc';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { KycTypes } from '@/types/kyc';
import validator from 'validator';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import { IdIsInvalid } from '@/utils/helpers';
import useTransactionsStore from '@/store/modules/transactions';
import { CountryTypes } from '@/types/country';
export default defineComponent({
    name: 'IDDetails2',
    props: {},
    components: {
        Button,
        WidgetInput,
        Input,
    },
    setup() {
        const kycStore = useKycStore();
        const { currentStep, idType, idNumber, additionalIdType, additionalIdNumber, requireDoubleIdNG, } = storeToRefs(kycStore);
        const authStore = useAuthStore();
        const { partnerId } = storeToRefs(authStore);
        const transactionStore = useTransactionsStore();
        const { countryConfig, activeSupportedCountryConfig } = storeToRefs(transactionStore);
        const { country } = countryConfig.value;
        onBeforeMount(() => {
            if (requireDoubleIdNG.value) {
                additionalIdType.value = CountryTypes.IdTypes.BVN;
                idType.value = CountryTypes.IdTypes.NIN;
            }
        });
        const rules = computed(() => ({
            // remove error messages while confirming correct error state
            idNumber: (value) => {
                const idTypeValidation = activeSupportedCountryConfig.value?.idTypeValidation.find(config => config.idType === idType.value);
                if (validator.isEmpty(value))
                    return ' ';
                if (IdIsInvalid(value, idTypeValidation?.regex, idTypeValidation?.regexFlag)) {
                    return ' ';
                }
                return true;
            },
            additionalIdNumber: (value) => {
                const idTypeValidation = activeSupportedCountryConfig.value?.idTypeValidation.find(config => config.idType === additionalIdType.value);
                if (validator.isEmpty(value) ||
                    IdIsInvalid(value, idTypeValidation?.regex, idTypeValidation?.regexFlag))
                    return ' ';
                return true;
            },
        }));
        const validateInputs = (newInput) => {
            if (requireDoubleIdNG.value) {
                return (rules.value.idNumber(newInput.idNumber) !== true ||
                    rules.value.additionalIdNumber(newInput.additionalIdNumber ?? '') !==
                        true);
            }
            return rules.value.idNumber(newInput.idNumber) !== true;
        };
        const isButtonDisabled = ref(true);
        isButtonDisabled.value = validateInputs({
            idNumber: idNumber.value,
            additionalIdNumber: additionalIdNumber.value,
        });
        const backClick = () => {
            if (requireDoubleIdNG.value) {
                currentStep.value = KycTypes.KycSteps.KYC_5;
            }
            else {
                currentStep.value = KycTypes.KycSteps.KYC_6;
            }
        };
        watch(idNumber, newInput => {
            isButtonDisabled.value = validateInputs({
                idNumber: newInput,
                additionalIdNumber: additionalIdNumber.value,
            });
        });
        watch(additionalIdNumber, newInput => {
            if (!newInput)
                return;
            isButtonDisabled.value = validateInputs({
                idNumber: idNumber.value,
                additionalIdNumber: newInput,
            });
        });
        const onKeyPress = () => {
            console.log('key pressed');
        };
        const proceed = () => {
            // submit data to be
            trackEvent(MIXPANEL_EVENTS.KYC.ID_NUMBER, {
                id_type: idType.value,
                partner: partnerId.value,
            });
            currentStep.value = KycTypes.KycSteps.KYC_8;
        };
        return {
            backClick,
            rules,
            proceed,
            isButtonDisabled,
            onKeyPress,
            idType,
            idNumber,
            requireDoubleIdNG,
            country,
            additionalIdType,
            additionalIdNumber,
            activeSupportedCountryConfig,
        };
    },
});
